import JwtToken from '@/services/jwt-token'
import { User, Application } from '@/services/resources'
import Storage from '@/services/Storage'

const sessionStorage = new Storage(window.sessionStorage)
const localStorage = new Storage(window.localStorage)

const state = {
  auth: {
    check: JwtToken.token != null,
    user: sessionStorage.getObject('user')
  },
  nextLogin: '/dashboard',
  appModules: sessionStorage.getObject('modules'),
  loading: false,
  info: sessionStorage.getObject('appInfo')
}

const getters = {
  user (state) {
    return state.auth.user
  },
  loading (state) {
    return state.loading
  },
  isAuthenticated (state) {
    return state.auth.check || false
  },
  modules (state) {
    return state.appModules
  },
  nextLogin (state) {
    return state.nextLogin
  },
  info (state) {
    return state.info
  }
}

const mutations = {
  update: function (state, valor) {
    state.view = valor
  },
  setUser (state, user) {
    sessionStorage.setObject('user', user)
    state.auth.user = user
  },
  authenticate (state) {
    state.auth.check = true
  },
  unauthenticate (state) {
    state.auth.check = false
    state.auth.user = null
    sessionStorage.remove('user')
    JwtToken.token = null
  },
  startLoading (state) {
    state.loading = true
  },
  endLoading (state) {
    state.loading = false
  },
  setModules (state, modules) {
    sessionStorage.setObject('modules', modules)
    state.appModules = { ...modules }
  },
  changeNextLogin (state, url) {
    state.nextLogin = url
  },
  setInfo (state, info) {
    sessionStorage.setObject('appInfo', info)
    state.info = info
  }
}

const actions = {
  login (context, { email, password }) {
    return JwtToken.accessToken(email, password).then(response => {
      context.commit('authenticate')
      context.dispatch('getUser')
      return response
    })
  },
  logout (context) {
    return JwtToken.unauthenticate().then(response => {
      context.commit('unauthenticate')
    })
  },
  getUser (context) {
    User.get().then(response => {
      context.commit('setUser', response.data.user)
      context.commit('setModules', response.data.appModules)
    })
  },
  /**
   * Registra o email e senha para o aluno de
   * acordo com a matrícula e a data de nascimento
   * deste, caso ele não possua
   *
   * @param {*} context
   */
  firstAccessRegister (context, params) {
    return User.firstAccessRegister(params)
      .then((response) => {
        localStorage.set('login_username', params.email)
        return response
      })
  },
  /**
   * Registra um aluno na plataforma
   *
   * @param {*} context
   */
  register (context, params) {
    return User.register(params)
      .then((response) => {
        localStorage.set('login_username', params.email)
        return response
      })
  },
  /**
   * Realiza compra de pacote de curso
   *
   * @param {*} context
   */
  order (context, params) {
    return User.order(params)
      .then((response) => {
        return response
      })
  },
  /**
   * Verifica se para determinada matrícula e data
   * de nascimento o aluno não possui email e senha
   * para login
   *
   * @param {*} context
   */
  firstAccessVerify (context, params) {
    return User.firstAccessVerify(params)
      .then((response) => {
        sessionStorage.set('first_access_enrollment', params.enrollment)
        sessionStorage.set('first_access_birth_date', params.birth_date)
        return response
      })
  },
  changeNextLogin (context, url) {
    context.commit('changeNextLogin', url)
  },
  async info (context) {
    if (!context.state.info) {
      const info = await Application.info()
      context.commit('setInfo', info.body)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
